"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoLogin = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _auth = require("../../redux/modules/auth");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _UserUtil = require("../../utils/UserUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoLogin = exports.AutoLogin = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AutoLogin, _Component);

  function AutoLogin() {
    (0, _classCallCheck3.default)(this, AutoLogin);
    return (0, _possibleConstructorReturn3.default)(this, (AutoLogin.__proto__ || (0, _getPrototypeOf2.default)(AutoLogin)).apply(this, arguments));
  }

  (0, _createClass3.default)(AutoLogin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.auth.user || !this.props.auth.regData) {
        this.props.pushRoute("/");
      } else {
        var auth = this.props.auth;

        this.props.login({
          email: this.props.auth.regData.email,
          password: this.props.auth.regData.password
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var auth = this.props.auth;
      var _props = this.props,
          user = _props.auth.user,
          pushRoute = _props.pushRoute;

      if (user && !(0, _UserUtil.isPaidUser)(user)) {
        if (this.props.auth.regData.email) {
          user.tempData = this.props.auth.regData;
        }
        console.info("user.tempData", user.tempData);
        if (user.tempData.invitation_token) {
          pushRoute("/omat-tietoni");
        } else {
          pushRoute("/maksullinen-profiili");
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Kirjaudutaan" }),
        _react2.default.createElement(
          "h1",
          { className: "h3" },
          "Kirjaudutaan j\xE4rjestelm\xE4\xE4n"
        ),
        _react2.default.createElement(
          "p",
          null,
          " ..."
        )
      );
    }
  }]);
  return AutoLogin;
}(_react.Component), _class.propTypes = {
  login: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object.isRequired
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, {
  login: _auth.login,
  pushRoute: _reactRouterRedux.push
})(AutoLogin);


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/AutoLogin/AutoLogin.js
 ** module id = 1208
 ** module chunks = 0
 **/